import React, { useEffect, useState } from 'react';

interface CountdownTimerProps {
    initialTime: number;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ initialTime }) => {
    const [totalTime, setTotalTime] = useState<number>(initialTime);

    useEffect(() => {
        const timerInterval = setInterval(() => {
            setTotalTime((prevTime) => {
                if (prevTime > 0) {
                    return prevTime - 1;
                } else {
                    clearInterval(timerInterval);
                    return 0;
                }
            });
        }, 1000);

        return () => clearInterval(timerInterval);
    }, []);

    const formatTime = (time: number): string => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    return (
        <div className="flex justify-center items-center bg-gray-100">
            <div className="border border-[#F0F0F0] rounded-lg p-4 flex items-center justify-center">
                <p className='text-[22px] text-gray-800 !font-[500] '>{formatTime(totalTime)}</p>
            </div>
        </div>
    );
};

export default CountdownTimer;